/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccAdvancedPatientDetails } from './PccAdvancedPatientDetails';
import {
    PccAdvancedPatientDetailsFromJSON,
    PccAdvancedPatientDetailsFromJSONTyped,
    PccAdvancedPatientDetailsToJSON,
    PccAdvancedPatientDetailsToJSONTyped,
} from './PccAdvancedPatientDetails';

/**
 * 
 * @export
 * @interface FindOnePccAdvancedPatientDetails200Response
 */
export interface FindOnePccAdvancedPatientDetails200Response {
    /**
     * 
     */
    data?: PccAdvancedPatientDetails;
}

/**
 * Check if a given object implements the FindOnePccAdvancedPatientDetails200Response interface.
 */
export function instanceOfFindOnePccAdvancedPatientDetails200Response(value: object): value is FindOnePccAdvancedPatientDetails200Response {
    return true;
}

export function FindOnePccAdvancedPatientDetails200ResponseFromJSON(json: any): FindOnePccAdvancedPatientDetails200Response {
    return FindOnePccAdvancedPatientDetails200ResponseFromJSONTyped(json, false);
}

export function FindOnePccAdvancedPatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOnePccAdvancedPatientDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PccAdvancedPatientDetailsFromJSON(json['data']),
    };
}

export function FindOnePccAdvancedPatientDetails200ResponseToJSON(json: any): FindOnePccAdvancedPatientDetails200Response {
    return FindOnePccAdvancedPatientDetails200ResponseToJSONTyped(json, false);
}

export function FindOnePccAdvancedPatientDetails200ResponseToJSONTyped(value?: FindOnePccAdvancedPatientDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PccAdvancedPatientDetailsToJSON(value['data']),
    };
}

